import { useField } from 'formik';
import React from 'react';

import { WLInput } from '../../design-library';

const SSN_INPUT_REGEX = /^(?:(\d{3})|\((\d{3})\))[-\s]?(\d{2})[-\s]?(\d{4})$/;

type SocialSecurityInputFieldProps = React.ComponentProps<typeof WLInput>;
const SocialSecurityInputField: React.FC<SocialSecurityInputFieldProps> = ({
  name,
  ...props
}) => {
  const [, , helpers] = useField(name!);
  const onChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange?.(event);

      const ssnResult = SSN_INPUT_REGEX.exec(event.target.value);
      if (ssnResult) {
        // regex returns 5 match entries [valueEntry, matchOption1, matchOption2, match3, match4]
        const formatInput = `${ssnResult[1] || ssnResult[2]}-${ssnResult[3]}-${
          ssnResult[4]
        }`;
        helpers.setValue(formatInput);
      } else {
        helpers.setValue(event.target.value);
      }
    },
    [props.onChange, helpers.setValue],
  );
  return <WLInput name={name} {...props} type="text" onChange={onChange} />;
};

export default SocialSecurityInputField;
